import { React, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Header from 'src/layouts/Header';
import Footer from 'src/layouts/Footer';
import RegisterForm from 'src/components/form/RegisterForm';
import useSEO from 'src/hooks/useSEO';

const Register = () => {
  useSEO({
    title: 'Register - SphynxPlace.com',
    description: 'Create your SphynxPlace account to start listing and finding Sphynx cats for sale, adoption, and stud services.',
    robots: 'noindex, nofollow',
  });
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    // Ako je korisnik već prijavljen, redirect-uj ga na home
    if (auth.isLoggedIn) {
      navigate('/', { replace: true });
    }
  }, [auth.isLoggedIn, navigate]);

  // Ako je korisnik prijavljen, ne prikazuj stranicu
  if (auth.isLoggedIn) {
    return null;
  }

  return (
    <>
      <Header />
      <div className="container mx-auto min-h-[calc(100vh-200px)] flex items-center justify-center py-8">
        <RegisterForm />
      </div>
      <Footer />
    </>
  );
};

export default Register;